import { defineComponent as _defineComponent } from 'vue'
import { useSlots } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthLayout',
  setup(__props) {

const slot = useSlots();

return { __sfc: true,slot }
}

})